import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';
import { ProductoService } from '../../servicios/producto.service'
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-modal-filtro-modelos',
  templateUrl: './modal-filtro-modelos.component.html',
  styleUrls: ['./modal-filtro-modelos.component.scss']
})
export class ModalFiltroModelosComponent implements OnInit {

  modelosField = new Array();

  modelos = {
    cargando: false,
    registros: new Array()
  };

  constructor(
    public globals: Globals,
    private productoService: ProductoService,
    public dialogRef: MatDialogRef<ModalFiltroModelosComponent>,
  ) { }

  cargarModelos(){
    this.productoService.modelosListado({
      categoria: this.globals.configuracion.front.listado.categoria
    }).subscribe(
      resultado =>{
        if( !resultado.error ){
          Array.prototype.push.apply( this.modelos.registros, resultado.registros );
          this.modelos.cargando = false;
        }else{
          console.log("Error",resultado.mensaje);
        }

      },
      error =>{
        console.log("Error",error);
        //this.feedProductos.cargando = false;
      }
    )
  }

  aceptarModelos(){
    this.dialogRef.close( this.modelosField );
  }

  ngOnInit(): void {
    this.modelosField = this.globals.configuracion.front.listado.modelos;
    this.cargarModelos();
  }

}
